// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.utilities_panel {
    margin:0;
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 20px;
    padding-right: 20px;
    border: 1px solid rgb(189, 189, 189);
    border-radius: 10px;
}

.utilities_panel-warning-underlined {
    font-style: italic;
    font-weight: bold;
    text-decoration: underline;
}

.utilities_panel-warning {
    font-weight: 600;
    color:red;
}`, "",{"version":3,"sources":["webpack://./src/components/AdminUtilitiesPanel.css"],"names":[],"mappings":"AAAA;IACI,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb","sourcesContent":[".utilities_panel {\n    margin:0;\n    padding-top: 0px;\n    padding-bottom: 0px;\n    padding-left: 20px;\n    padding-right: 20px;\n    border: 1px solid rgb(189, 189, 189);\n    border-radius: 10px;\n}\n\n.utilities_panel-warning-underlined {\n    font-style: italic;\n    font-weight: bold;\n    text-decoration: underline;\n}\n\n.utilities_panel-warning {\n    font-weight: 600;\n    color:red;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
